import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycMedicaidAndHomeCarePage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-medicaid-and-home-care/']} />;
}
